import { Component } from 'react';
import { Container } from 'components/Container/Container';
import { TextHeader } from 'components/Typography/TextHeader';

class GlobalErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch = async (error, info) => {
    // You can also log the error to an error reporting service
    console.error(error);
    console.log(info);
    const errorUuid = 123; // set a dynamic error id here and sync with server side
    this.setState({ hasError: true, errorUuid });
  };

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Container>
          <TextHeader>{'Something went wrong'}</TextHeader>
        </Container>
      );
    }
    return this.props.children;
  }
}

export default GlobalErrorBoundary;
